import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../App'

const FieldUpdateIndicator = ({ fieldName }) => {
  const { state } = useContext(AppContext)
  const [fadeOut, setFadeOut] = useState(false)

  useEffect(() => {
    setFadeOut(false)

    setTimeout(() => {
      setFadeOut(true)
    }, 700)
  }, [state.editor.updatedField[fieldName]])
  return (
    <svg
      className={`ml-2 transition-opacity duration-700 ${fadeOut ? 'opacity-0' : 'opacity-100'}`}
      xmlns='http://www.w3.org/2000/svg'
      width='1.2em'
      height='1.2em'
      viewBox='0 0 24 24'
      style={{ display: 'inline' }}
    >
      <path fill='#27d39a' d='M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8z' />
    </svg>
  )
}

export { FieldUpdateIndicator }
